<template>
  <div>
    <b-navbar id="nav-bar" type="dark" fixed="top" ref="navbarCollapse">
      <div
        class="mr-0 brand-section"
        v-b-tooltip.v-secondary.noninteractive.hover="
          $t('reusable.navbar.goToHome')
        "
        @click="closeMenuNoLoged2"
      >
        <router-link :to="{ name: isLoged ? 'DashboardView' : 'Welcome' }">
          <!-- Deshabilitado: logo por subdominio. El :title original usaba
          subdomain_institution_name como fallback:
          :title="institution ? institution.name : subdomain_institution_name || ''" -->
          <b-img
            v-if="
              !isLoged || institution_logo == null || institution_logo == 'null'
            "
            v-bind:src="logo"
            :alt="app_name"
            class="logo pt-1 pb-1 mr-auto mt-1"
            :title="institution ? institution.name : ''"
            style="cursor: pointer"
          ></b-img>
          <b-img
            v-if="
              isLoged &&
              institution_logo &&
              institution_logo != null &&
              institution_logo != 'null'
            "
            thumbnail
            v-bind:src="institution_logo"
            :alt="institution ? institution.name : ''"
            class="logo mr-auto"
            :title="institution ? institution.name : ''"
          ></b-img>
          <b-navbar-brand v-if="!isLoged" class="brand-text mr-auto">
          </b-navbar-brand>
          <!-- Nombre de la institución solo como fallback: cuando está logueado
          pero NO hay logo de institución (el logo lo identifica si existe). -->
          <b-navbar-brand
            v-else-if="!institution_logo || institution_logo == 'null'"
            class="brand-text mr-auto"
          >
            {{ institution ? institution.name : "" }}
          </b-navbar-brand>
        </router-link>
      </div>
      <div
        class="user-info-container"
        v-bind:class="{ 'right-setting': !isLoged }"
      >
        <b-navbar-nav>
          <b-nav
            class="landing-nav"
            v-bind:class="{ 'not-visible': isLoged || app_name == 'GERA' }"
          >
            <div class="nav-items">
              <b-nav-item style="margin-left: 1%" :to="{ name: 'Welcome' }">
                <span :class="{ 'current-view': $route.name == 'Welcome' }">
                  {{ $t("reusable.navbar.home") }}
                </span>
              </b-nav-item>
              <b-nav-item style="margin-left: 1%" :to="{ name: 'AboutUsView' }">
                <span :class="{ 'current-view': $route.name == 'AboutUsView' }">
                  {{ $t("reusable.navbar.aboutUs") }}
                </span>
              </b-nav-item>
              <b-nav-item
                style="margin-left: 1%"
                :to="{ name: 'InstitutionsView' }"
              >
                <span
                  :class="{
                    'current-view': $route.name == 'InstitutionsView',
                  }"
                >
                  {{ $t("home.institutionsView.institutions") }}
                </span>
              </b-nav-item>
              <!-- <b-nav-item
                style="margin-left: 1%"
                :to="{ name: 'SolutionsView' }"
              >
                <span
                  :class="{ 'current-view': $route.name == 'SolutionsView' }"
                >
                  {{ $t("reusable.navbar.solutions") }}
                </span>
              </b-nav-item> -->
              <!-- <b-nav-item
                style="margin-left: 1%"
                :to="{ name: 'TrainingView' }"
              >
                <span
                  :class="{ 'current-view': $route.name == 'TrainingView' }"
                >
                  {{ $t("reusable.navbar.training") }}
                </span>
              </b-nav-item> -->
              <!-- <b-nav-item style="margin-left: 1%">
                <span :class="{ 'current-view': $route.name == 'Contact' }">
                  Contacto
                </span>
              </b-nav-item> -->
            </div>
          </b-nav>
          <!-- Modo edición + impresión (antes vivían en la barra de recursos) -->
          <PrintFab v-if="isLoged" class="noprint navbar-print-fab mr-1">
            <button
              v-if="visibility_crud"
              type="button"
              class="edit-mode-toggle"
              :class="{ 'is-on': local_allows_crud }"
              :aria-pressed="local_allows_crud ? 'true' : 'false'"
              @click="
                local_allows_crud = !local_allows_crud;
                mutateAllowsCrud();
              "
            >
              <b-icon
                :icon="local_allows_crud ? 'pencil-fill' : 'pencil'"
                class="edit-mode-toggle__icon"
              ></b-icon>
              <span class="edit-mode-toggle__text">{{
                $t("reusable.navbar.editMode")
              }}</span>
              <span class="edit-mode-toggle__switch">
                <span class="edit-mode-toggle__knob"></span>
              </span>
            </button>
            <b-dropdown
              label="Opciones"
              size="sm"
              variant="info"
              class="b-dropdown-container p-0 m-0"
              split
              @click="generateReport"
            >
              <template #button-content>
                <b-icon-printer class="icon-print-navbar"></b-icon-printer>
              </template>
              <b-dropdown-form style="width: 210px" class="pb-0 pt-0 pl-1 pr-1">
                <b-form-group>
                  <span class="options-print-range">{{
                    $t("reusable.navbar.printOrientation")
                  }}</span>
                  <b-form-checkbox
                    class="options-print mt-1"
                    name="print-vertical"
                    switch
                    v-model="local_print_orientation"
                    @change="updatePrintOrientation"
                  >
                    <span v-if="local_print_orientation">
                      <b-icon icon="tablet-landscape" class="mt-1"></b-icon>
                      {{ $t("reusable.navbar.horizontal") }}
                    </span>
                    <span v-else>
                      <b-icon icon="tablet" class="mt-1"></b-icon>
                      {{ $t("reusable.navbar.vertical") }}
                    </span>
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group
                  :label="$t('reusable.navbar.printZoom')"
                  class="mt-2 options-print-range"
                >
                  <b-input-group>
                    <b-form-input
                      type="range"
                      v-model="local_print_zoom_scale"
                      :min="0.3"
                      :max="1.5"
                      :step="0.05"
                      @input="updatePrintZoom"
                    ></b-form-input>
                    <b-input-group-append is-text class="text-monospace">
                      {{ (local_print_zoom_scale * 100).toFixed(0) }}%
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-dropdown-form>
            </b-dropdown>
          </PrintFab>
          <HelpComponent class="help-icon" v-if="isLoged"></HelpComponent>
          <!-- Perfil de usuario -->
          <b-nav class="profile-nav">
            <!-- TODO: Se oculta seccion de Idioma hasta que este finalizado -->
            <div v-if="isLoged" class="align-content-center">
              <Language :isLoged="isLoged"></Language>
            </div>
            <b-nav-item-dropdown
              v-if="isLoged"
              disabled
              right
              :class="{
                'dropdown-adjustment': isLoged,
                shown: isLoged,
                'sign-in': !isLoged,
              }"
            >
              <template #button-content>
                <em
                  class="user-name user-name--role"
                  :style="{ textDecorationColor: userIconColor }"
                  >{{ userName }}</em
                >
                <b-img
                  v-if="userImage"
                  :src="userImage"
                  class="user-photo"
                  rounded="circle"
                  :alt="userName"
                ></b-img>
                <b-icon
                  v-else
                  class="user-icon"
                  icon="person-circle"
                  :style="{ color: userIconColor }"
                ></b-icon>
              </template>
              <b-dropdown-text v-if="user && user.email" class="user-email">
                <b-icon icon="envelope" class="mr-2"></b-icon>{{ user.email }}
              </b-dropdown-text>
              <b-dropdown-text
                v-if="user && getRole(user)"
                class="user-email user-role"
              >
                <b-icon icon="person-badge" class="mr-2"></b-icon
                >{{ getRole(user) }}
              </b-dropdown-text>
              <b-dropdown-divider
                v-if="user && user.email"
              ></b-dropdown-divider>
              <b-dropdown-item :to="{ name: 'UseCardView' }">{{
                $t("reusable.navbar.profile")
              }}</b-dropdown-item>
              <b-dropdown-item @click="$logOut">{{
                $t("reusable.navbar.logout")
              }}</b-dropdown-item>
            </b-nav-item-dropdown>

            <template v-else>
              <div class="d-flex">
                <!-- Language Toggle -->
                <!-- TODO: Se oculta seccion de Idioma hasta que este finalizado -->
                <div v-if="!isLoged" class="language-toggle-container mr-3">
                  <Language :isLoged="isLoged"></Language>
                </div>
                <!-- Login Button -->
                <b-button
                  variant="none"
                  :to="{ name: 'Login' }"
                  class="user-button p-0"
                >
                  <div class="user-button-left mr-2 pl-3">
                    {{ $t("reusable.navbar.enter") }}
                  </div>
                  <div class="user-button-right" @click="closeMenuNoLoged2">
                    <b-icon
                      class="user-icon2"
                      scale="1.8"
                      icon="person-circle"
                    ></b-icon>
                  </div>
                </b-button>
              </div>
            </template>
          </b-nav>
        </b-navbar-nav>
      </div>
      <div
        class="mobile-nav"
        :class="{ 'not-visible': isLoged || app_name == 'KL' }"
        @click="closeMenuNoLoged"
        @click.stop
        v-b-toggle.navbar-toggle-collapse
      >
        <b-button ref="collapseButton" class="btn-collapse-mobile">
          <b-icon v-if="expanded" icon="caret-up-fill"></b-icon>
          <b-icon v-else icon="caret-down-fill"></b-icon>
        </b-button>
      </div>
    </b-navbar>
    <div :class="{ 'not-logged-in': !isLoged }" class="loadingBar noprint">
      <b-progress
        :value="loading_value"
        v-if="loading"
        height="7px"
        :max="loading_max"
        animated
      ></b-progress>
    </div>
    <b-collapse
      v-if="expanded"
      :class="{ 'not-visible': isLoged || app_name == 'KL' }"
      id="navbar-toggle-collapse"
      class="mobile-nav"
    >
      <div class="nav-btn">
        <b-button
          :to="{ name: 'Welcome' }"
          class="navigation-link m-1"
          variant="info"
          @click="closeMenuNoLoged"
        >
          {{ $t("reusable.navbar.home") }}
        </b-button>
        <!-- <b-button
          :to="{ name: 'SolutionsView' }"
          class="navigation-link m-1"
          variant="info"
          @click="closeMenuNoLoged"
        >
          {{ $t("reusable.navbar.solutions") }}
        </b-button> -->
        <b-button
          :to="{ name: 'AboutUsView' }"
          class="navigation-link m-1"
          variant="info"
          @click="closeMenuNoLoged"
        >
          {{ $t("reusable.navbar.aboutUs") }}
        </b-button>
        <b-button
          :to="{ name: 'InstitutionsView' }"
          class="navigation-link m-1"
          variant="info"
          @click="closeMenuNoLoged"
        >
          {{ $t("home.institutionsView.institutions") }}
        </b-button>
        <!-- <b-button
          :to="{ name: 'TrainingView' }"
          class="navigation-link m-1"
          variant="info"
          @click="closeMenuNoLoged"
        >
          {{ $t("reusable.navbar.training") }}
        </b-button> -->
      </div>
    </b-collapse>
    <!-- Alert -->
    <div v-if="$maintenance_alert.show">
      <b-alert
        show
        dismissible
        variant="warning"
        class="w-100 mt-3 mb-0 text-center"
      >
        {{ $maintenance_alert.message }}
      </b-alert>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/utils/utils";
import { APP_NAME } from "@/utils/globals";
import { mapGetters } from "vuex";
import * as names from "@/store/names";
import Vue from "vue";
import VueClosable from "vue-closable";
// Deshabilitado: logo por subdominio (ver loadSubdomainLogo más abajo).
// import axios from "@/utils/api";
Vue.use(VueClosable);

export default {
  name: "NavBar",
  components: {
    HelpComponent: () => import("@/components/reusable/HelpComponent"),
    PrintFab: () => import("@/components/reusable/PrintFab"),
    // TODO: Se oculta seccion de Idioma hasta que este finalizado
    Language: () => import("@/components/reusable/Language"),
    // ToolbarAi: () => import("@/components/public/ToolbarAi"),
  },
  data() {
    return {
      sisera_logo: require("@/assets/new-page/KEY_LEARNING_LOGO.svg"),
      // Deshabilitado: logo por subdominio.
      // subdomain_logo: null,
      // subdomain_institution_name: null,
      welcomeMessage: "",
      loading: false,
      loading_value: 0,
      loading_max: 0,
      app_name: APP_NAME,
      login_redirect: false,
      expanded: false,
      expanded1: false,
      expanded2: false,
      expanded3: false,
      expanded4: false,
      // SEC-3: leer del store (ya no se persiste en localStorage).
      local_allows_crud: this.$store.state.utils.allows_crud,
      local_print_orientation: false,
      previous_print_orientation: false,
      local_print_zoom_scale: 1,
      previous_print_zoom_scale: 1,
      local_title_of_the_print: null,
      roles: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      isLoged: "isLoged",
      institution: "getInstitution",
      institution_logo: "getInstitutionLogo",
      images: names.IMAGES,
      allows_crud: names.ALLOWS_CRUD,
      visibility_crud: names.VISIBILITY_CRUD,
      print_zoom_scale: names.PRINT_ZOOM_SCALE,
      print_orientation: names.PRINT_ORIENTATION,
      title_of_the_print: names.TITLE_OF_THE_PRINT,
    }),
    logo() {
      // Deshabilitado: logo por subdominio.
      // if (this.subdomain_logo) return this.subdomain_logo;
      return this.sisera_logo;
    },
    userName() {
      let username = "Usuario";
      if (this.user) {
        username = this.user.email;
        if (this.user.first_name) username = this.user.first_name;
        if (this.user.last_name)
          username = this.user.first_name + " " + this.user.last_name;
      }
      return username;
    },
    // ID de la imagen de perfil (viene en user.user_data.image, no la URL).
    userImageId() {
      if (this.user && this.user.user_data && this.user.user_data.image)
        return this.user.user_data.image;
      return null;
    },
    // Foto del usuario: la URL vive en el store de imágenes (igual que
    // ImageEditor la resuelve por image_id). Si no está, el template cae al
    // ícono person-circle habitual.
    userImage() {
      if (!this.userImageId) return null;
      const image = this.images.find((x) => x.id == this.userImageId);
      return image ? image.image : null;
    },
    // Color del ícono de usuario según su rol. Se evalúa por prioridad: el
    // superusuario manda, y si pertenece a varios grupos se toma el primero
    // de la lista `roleColorPriority`.
    roleColorPriority() {
      return [
        { group: "DIRECTIVOS ACADÉMICOS INSTITUCIONALES", color: "#6d0923" }, // Rojo vino / guinda
        { group: "DIRECTIVOS ACADÉMICOS (CAMPUS)", color: "#bc1c31" }, // rojo
        { group: "DIRECTIVOS FACULTAD O ESCUELA", color: "#5e143a" }, // Morado vino
        { group: "DIRECTORES DE CARRERA", color: "#0058bc" }, // azul oscuro
        { group: "DIRECTORES DE CARRERA (CAMPUS)", color: "#5ca4ef" }, // Azul más claro
        { group: "PROFESORES", color: "#006400" }, // verde oscuro
        { group: "ADMINISTRATIVOS INSTRUCCIONALES", color: "#D65D00" }, // naranjo
        { group: "ESTUDIANTES", color: "#8B4513" }, // café
        { group: "VISITANTES", color: "#959893" }, // gris
      ];
    },
    userIconColor() {
      if (!this.user) return "#FFFFFF";
      if (this.user.is_superuser) return "#060606"; // negro
      const groups = this.user.group_names || [];
      const match = this.roleColorPriority.find((r) =>
        groups.includes(r.group)
      );
      return match ? match.color : "#FFFFFF";
    },
  },
  methods: {
    getRole(user) {
      if (user.is_superuser == true) return this.$t("toolbar.acts.superUser");
      const role = this.roles.find((x) => x.id == user.role);
      return role ? role.position_name : "";
    },
    // Los roles dependen de la institución (school) del usuario. Se re-obtienen
    // en el created y cada vez que cambia el usuario/institución (ver watch),
    // porque el NavBar se crea una sola vez y persiste entre sesiones.
    fetchRoles() {
      this.$restful.GetAll(`/teaching/roles/`).then((response) => {
        this.roles = response;
      });
    },
    // Trae al store la imagen de perfil si aún no está cargada, para poder
    // resolver su URL en el computed userImage.
    fetchUserImage() {
      if (!this.userImageId) return;
      const cached = this.images.find((x) => x.id == this.userImageId);
      if (!cached) this.$store.dispatch(names.FETCH_IMAGE, this.userImageId);
    },
    // Deshabilitado: logo por subdominio.
    // async loadSubdomainLogo() {
    //   const hostname = window.location.hostname;
    //   // Only on subdomains of klearning.cl (e.g., ipss.klearning.cl)
    //   if (
    //     !hostname.includes("klearning.cl") ||
    //     hostname === "klearning.cl" ||
    //     hostname === "www.klearning.cl"
    //   ) {
    //     return;
    //   }
    //   const parts = hostname.split(".");
    //   if (parts.length < 3) return;
    //   const urlSubdomain = parts[0].replace(/-dev$/, "");

    //   try {
    //     const response = await axios.get("/authentication/subdomain-logo/", {
    //       params: { subdomain: urlSubdomain },
    //     });
    //     const { logo_url, name } = response.data;
    //     if (logo_url) this.subdomain_logo = logo_url;
    //     if (name) this.subdomain_institution_name = name;
    //   } catch (error) {
    //     // Silently fail - will show default KLearning logo
    //   }
    // },
    changeStateMobileMenu(btn_number) {
      if (btn_number == 1) this.expanded1 = !this.expanded1;
      else this.expanded1 = false;
      if (btn_number == 2) this.expanded2 = !this.expanded2;
      else this.expanded2 = false;
      if (btn_number == 3) this.expanded3 = !this.expanded3;
      else this.expanded3 = false;
      if (btn_number == 4) this.expanded4 = !this.expanded4;
      else this.expanded4 = false;
    },
    menuExpandOutside() {
      this.expanded = !this.expanded;
    },
    closeMenu() {
      //Metodo para cerrar el menu cuando se hace click en un boton del menú
      this.expanded = !this.expanded;
      this.closeSubmenus();
    },
    closeMenuNoLoged() {
      this.expanded = !this.expanded;
    },
    closeMenuNoLoged2() {
      this.expanded = false;
    },
    menuExpand() {
      this.expanded = !this.expanded;
      if (!this.expanded) {
        // Si se cierra el menú, se asegura de cerrar los submenús
        this.closeSubmenus();
        this.removeClickOutsideListener();
      } else {
        // Agrega el listener cuando el menú se expande
        this.addClickOutsideListener();
      }
    },
    closeSubmenus() {
      if (this.expanded1)
        this.$root.$emit("bv::toggle::collapse", "accordion-1");
      if (this.expanded2)
        this.$root.$emit("bv::toggle::collapse", "accordion-2");
      if (this.expanded3)
        this.$root.$emit("bv::toggle::collapse", "accordion-3");
      if (this.expanded4)
        this.$root.$emit("bv::toggle::collapse", "accordion-4");

      this.expanded1 = false;
      this.expanded2 = false;
      this.expanded3 = false;
      this.expanded4 = false;
    },
    handleClickOutside(event) {
      if (!this.$refs.menuContainer.contains(event.target)) {
        this.menuExpand(); // Cierra el menú logueado
      }
    },
    addClickOutsideListener() {
      document.addEventListener("click", this.handleClickOutside);
    },
    removeClickOutsideListener() {
      document.removeEventListener("click", this.handleClickOutside);
    },
    mutateAllowsCrud() {
      if (this.local_allows_crud != this.allows_crud) {
        this.$store.commit(names.MUTATE_ALLOWS_CRUD, this.local_allows_crud);
      }
    },
    generateReport() {
      if (!this.local_allows_crud || !this.visibility_crud) {
        window.print();
      } else
        this.$swal({
          title: this.$t("reusable.navbar.exitEditModeWarning"),
          type: "warning",
          showCancelButton: false,
        });
    },
    handleBeforePrint() {
      // Antes de imprimir
      document.title = APP_NAME;
      if (this.institution) document.title = this.institution.name;
      if (this.local_title_of_the_print != null)
        document.title = this.local_title_of_the_print;
    },
    handleAfterPrint() {
      // Después de imprimir
      document.title = APP_NAME;
    },
    updatePrintStyles(orientation) {
      const style = document.createElement("style");
      style.setAttribute("id", "print-styles");
      style.innerHTML = `
        @media print {
          @page {
            size: ${orientation};
          }
          body {
            zoom: ${this.local_print_zoom_scale};
          }
        }
      `;
      const existingStyle = document.getElementById("print-styles");
      if (existingStyle) {
        existingStyle.parentNode.removeChild(existingStyle);
      }
      document.head.appendChild(style);
    },
    updatePrintOrientation() {
      const orientation = this.local_print_orientation
        ? "landscape"
        : "portrait";
      this.updatePrintStyles(orientation);
    },
    updatePrintZoom() {
      this.$store.commit(
        names.MUTATE_PRINT_ZOOM_SCALE,
        this.local_print_zoom_scale
      );
      this.updatePrintStyles(
        this.local_print_orientation ? "landscape" : "portrait"
      );
    },
  },
  watch: {
    print_zoom_scale(value) {
      if (value == 0) {
        this.local_print_zoom_scale = this.previous_print_zoom_scale;
        this.updatePrintStyles(
          this.local_print_orientation ? "landscape" : "portrait"
        );
      } else if (value > 0) {
        this.previous_print_zoom_scale = this.local_print_zoom_scale;
        this.local_print_zoom_scale = value;
        this.updatePrintStyles(
          this.local_print_orientation ? "landscape" : "portrait"
        );
      }
    },
    title_of_the_print(value) {
      this.local_title_of_the_print = value;
    },
    print_orientation(value) {
      if (value === null) {
        this.local_print_orientation = this.previous_print_orientation;
        this.updatePrintStyles(
          this.local_print_orientation ? "landscape" : "portrait"
        );
      } else if (value != null && (value === true || value === false)) {
        this.previous_print_orientation = this.local_print_orientation;
        this.local_print_orientation = value;
        this.updatePrintStyles(
          this.local_print_orientation ? "landscape" : "portrait"
        );
      }
    },
    isLoged(value) {
      if (!value) this.local_allows_crud = false;
    },
    userImageId() {
      this.fetchUserImage();
    },
    // Re-obtiene los roles al cambiar de sesión o institución: la lista de
    // roles se filtra por el school del usuario, así que si cambia el school
    // (re-login o cambio de institución) hay que refrescarla.
    user(newVal, oldVal) {
      const newSchool = newVal ? newVal.school : null;
      const oldSchool = oldVal ? oldVal.school : null;
      if (newSchool && newSchool !== oldSchool) {
        this.fetchRoles();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("beforeprint", this.handleBeforePrint);
    window.removeEventListener("afterprint", this.handleAfterPrint);
    this.removeClickOutsideListener();
  },
  mounted() {
    window.addEventListener("beforeprint", this.handleBeforePrint);
    window.addEventListener("afterprint", this.handleAfterPrint);
  },
  created() {
    if (this.isLoged) this.fetchRoles();
    this.updatePrintStyles("portrait");
    this.fetchUserImage();
    // Deshabilitado: logo por subdominio.
    // if (!this.isLoged) {
    //   this.loadSubdomainLogo();
    // }
    EventBus.$on("loadStarted", () => {
      this.loading = true;
    });
    EventBus.$on("loadFinished", () => {
      this.loading = false;
    });
    EventBus.$on("increment", (max) => {
      this.loading_max = max;
    });
    EventBus.$on("decrement", (value) => {
      this.loading_value = value;
    });
  },
};
</script>

<style scoped>
.language-toggle-container {
  display: flex;
  align-items: center;
}
.modern-accordion {
  border: none;
  background: linear-gradient(
    135deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  ) !important;
  box-shadow: 0 4px 20px rgba(16, 38, 73, 0.12);
  border-radius: 10px;
  overflow: hidden;
}

.modern-accordion-btn {
  font-weight: bold;
  padding: 5px;
  text-align: center;
  width: 100%;
  background: none;
}

.modern-nav-link {
  color: var(--kl-color-primary);
  font-weight: bold;
  padding: 3px;
  text-align: left;
  width: 100%;
  background-color: #f8f9fa;
  border-radius: 0px !important;
}
.modern-nav-btn {
  background-color: #ffffff;
  color: white !important;
  padding: 5px 0px 5px 10px;
  margin: 0px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.img-thumbnail {
  border: 0px;
}
.button-content {
  color: var(--kl-color-secondary);
  opacity: 1;
}
.dropdown-adjustment >>> .dropdown-menu {
  text-transform: uppercase;
  font-style: normal;
  font-weight: var(--kl-fw-regular);
  font-size: 12px;
  line-height: 17px;
}
.user-button:hover {
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 12px 26px rgba(0, 110, 200, 0.3);
}
.user-button {
  display: flex;
  background: linear-gradient(
    135deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  );
  width: 11em;
  height: 4em;
  color: white;
  border-radius: 55px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 110, 200, 0.22);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  font-style: normal;
  font-weight: var(--kl-fw-regular);
  font-size: 12px;
  line-height: 17px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.user-button-left {
  text-align: left;
}
.user-button-right {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.18);
  border-top-right-radius: 55px;
  border-bottom-right-radius: 55px;
}
.user-info-container {
  display: flex;
  align-items: center;
  width: auto;
  height: 100%;
  font-size: 15px;
  margin-left: auto;
  transition: 0.2s;
}
/* El selector de idioma (logueado) traía un margin-top que descuadraba */
.user-info-container >>> .language-flag {
  margin-top: 0 !important;
  margin-right: 12px;
}
.navbar {
  background-color: var(--kl-surface);
  box-shadow: 0 1px 4px rgba(16, 38, 73, 0.08);
  border-bottom: 1px solid var(--kl-border-soft);
  position: fixed;
  height: 4.1em;
  /* Sin z-index el navbar queda con auto (0) y el breadcrumb sticky (800),
  que se solapa 2px bajo su borde, lo taparía. */
  z-index: 1000;
}
/* Si la vista tiene breadcrumb sticky (marca puesta por NavigationBreadcrumb),
la sombra baja al breadcrumb y el borde inferior se quita, para que el bloque
navbar+breadcrumb se vea como una sola pieza sin línea intermedia. Sin
breadcrumb, el navbar conserva ambos. */
body.kl-has-breadcrumb .navbar {
  box-shadow: none;
  border-bottom: none;
}
/* ---- Clúster superior derecho (logueado): edición · impresión · idioma ---- */
.navbar-print-fab {
  display: flex;
  align-items: center;
}
/* Anular márgenes/transform heredados de PrintFab (venían de la barra azul) */
.navbar-print-fab >>> .print-fab,
.navbar-print-fab >>> .toggle-crud {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 !important;
  transform: none !important;
}
/* Toggle moderno "Modo edición" (chip + mini switch propio) */
.edit-mode-toggle {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  height: 30px;
  padding: 0 12px;
  border: 1px solid var(--kl-border-soft);
  border-radius: 999px;
  background: var(--kl-bg-page);
  color: var(--kl-text-heading);
  font-size: 0.8rem;
  font-weight: var(--kl-fw-semibold);
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease,
    box-shadow 0.2s ease;
}
.edit-mode-toggle:hover {
  border-color: #cfe0ee;
  background: #eef4f7;
}
.edit-mode-toggle:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 110, 200, 0.15);
}
.edit-mode-toggle.is-on {
  background: linear-gradient(
    135deg,
    rgba(0, 110, 200, 0.1) 0%,
    rgba(1, 173, 183, 0.1) 100%
  );
  border-color: rgba(0, 110, 200, 0.35);
  color: var(--kl-color-primary);
}
.edit-mode-toggle__icon {
  font-size: 0.92rem;
}
.edit-mode-toggle__text {
  line-height: 1;
}
/* Mini switch */
.edit-mode-toggle__switch {
  position: relative;
  width: 34px;
  height: 18px;
  border-radius: 999px;
  background: #cdd8e3;
  transition: background 0.2s ease;
  flex-shrink: 0;
}
.edit-mode-toggle.is-on .edit-mode-toggle__switch {
  background: linear-gradient(
    135deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  );
}
.edit-mode-toggle__knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(16, 38, 73, 0.3);
  transition: transform 0.22s ease;
}
.edit-mode-toggle.is-on .edit-mode-toggle__knob {
  transform: translateX(16px);
}
.navbar-nav {
  float: left;
  white-space: nowrap !important;
  display: flex;
  align-items: center;
}
.responsive-bar {
  display: none;
}
.current-view {
  color: var(--kl-color-primary) !important;
  font-weight: var(--kl-fw-bold);
  position: relative;
}
.current-view::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6px;
  height: 3px;
  border-radius: 3px;
  background: linear-gradient(
    90deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  );
}
.landing-nav {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 2px;
  flex-wrap: wrap;
  margin-left: -18%;
  margin-right: 6%;
}
.navbar-nav >>> .nav-link {
  color: var(--kl-text-body) !important;
  max-height: 40px;
  cursor: pointer;
  margin-left: 2em;
  font-weight: var(--kl-fw-semibold);
  padding: 6px 10px !important;
  border-radius: 10px;
  transition: color 0.2s ease, background 0.2s ease;
}
.navbar-nav >>> .nav-link:hover {
  background: #eef4f7;
  color: var(--kl-color-primary) !important;
  border-radius: 10px;
}
.items-dropdown >>> .dropdown-menu {
  width: 90%;
  left: 12%;
  margin-top: 0 !important;
}
.landing-nav >>> .nav-items {
  display: flex;
  flex-wrap: nowrap;
  font-size: 14pt !important;
  min-width: 400px;
  gap: 2rem;
  text-align: center;
}
.landing-nav .nav-items b-nav-item {
  margin: 0 5px;
}
.landing-nav .nav-items b-nav-item {
  color: #666;
  text-decoration: none;
  font-size: 14pt !important;
  font-weight: var(--kl-fw-medium);
  padding: 8px 6px;
  border-radius: 5px;
  letter-spacing: 1px;
  transition: all 0.2s ease;
}
.landing-nav .nav-items b-nav-item.active,
.landing-nav .nav-items b-nav-item:hover {
  color: var(--header-color);
  background: #fff;
}
.landing-nav .menu-btn i {
  color: #666;
  font-size: 28px;
  cursor: pointer;
  display: none;
}
.nav-items >>> .nav-link {
  margin-left: 2em !important;
}
.brand-text {
  justify-content: start;
  margin-left: 10px;
  padding-left: 10px;
  position: relative;
  margin-right: -15% !important;
  font-size: var(--secondary-font-size) - 2;
}
.dropdown-item {
  margin: 0px;
  padding: 0px;
  color: white;
  background-color: transparent;
}
.not-visible {
  display: none !important;
}
.logo {
  margin-left: 1em !important;
  max-width: 200px;
  max-height: 60px;
  min-height: 60px;
  min-width: 60px;
}
.searchInput {
  margin: 4px;
}
.loadingBar {
  position: fixed;
  top: 4.1em;
  left: 0;
  right: 0;
  width: 100%;
  margin-top: 0;
  /* El z-index debe ir en este contenedor (fixed crea su propio stacking
  context): el 900 del .progress interno no compite contra elementos externos
  como el breadcrumb sticky (800). */
  z-index: 900;
}
.not-logged-in {
  position: fixed;
  top: 4.1em !important;
  left: 0;
  right: 0;
  width: 100%;
  margin-top: 0;
}
.loadingBar >>> .progress {
  z-index: 900 !important;
  border-radius: 0;
}
.user-name {
  color: var(--kl-text-heading);
  opacity: 1;
  font-style: normal;
  font-weight: var(--kl-fw-semibold);
  font-size: 0.88rem;
  padding-right: 0.4em;
}
/* Subrayado que identifica el rol: siempre presente (haya o no foto). El
   color se aplica inline con userIconColor. Cambiar text-decoration-style
   entre solid/dashed/dotted/double/wavy según se prefiera. */
.user-name--role {
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
}
.user-icon {
  color: var(--kl-color-secondary);
  opacity: 1;
  font-size: 1.15rem;
}
.user-email >>> .b-dropdown-text {
  color: var(--kl-text-muted);
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-regular);
  text-transform: none;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-photo {
  width: 1.6rem;
  height: 1.6rem;
  object-fit: cover;
  vertical-align: middle;
}
.user-icon2 {
  color: white;
}
.profile-section {
  right: 0 !important;
  margin-left: 24%;
}
.profile-section:hover {
  cursor: pointer;
  background: var(--header-hover-color);
  border-radius: 6px;
}
.right-setting {
  margin-right: 0px !important;
}
.profile-section >>> .dropdown-menu {
  transform: translateY(-54%);
  right: 0;
  left: -25%;
}
.sign-in {
  height: 70px;
}

.mobile-nav {
  display: none;
}
.btn-collapse-mobile {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  ) !important;
  border: none !important;
  color: #fff !important;
  box-shadow: 0 6px 16px rgba(0, 110, 200, 0.22);
}
.card-body {
  padding: 0;
}
.nav-btn {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  background: var(--kl-surface);
  border-bottom: none;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 14px 34px rgba(16, 38, 73, 0.18);
  position: fixed;
  z-index: 2000;
  top: 4.1em;
  left: 0;
  width: 100%;
}
.navigation-drop {
  color: #fff;
  background: var(--kl-color-secondary) !important;
}
.navigation-drop:hover,
.navigation-link:hover {
  background: linear-gradient(
    135deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  ) !important;
  color: #fff !important;
  border-color: transparent !important;
}
.navigation-item {
  display: block;
  background: rgb(245, 245, 245);
  margin: 2px;
}
.navigation-item a {
  color: var(--secondary-font-color);
}
.navigation-item:hover {
  background: var(--header-hover-color);
}
.navigation-item:hover a {
  color: white;
}
.navigation-link {
  width: 100%;
  color: var(--kl-text-heading) !important;
  background: var(--kl-bg-page) !important;
  border: 1px solid var(--kl-border-soft) !important;
  border-radius: 10px !important;
  font-weight: var(--kl-fw-semibold);
  text-align: left;
  padding: 10px 14px;
  margin: 0 !important;
  height: auto;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.shown {
  display: block !important;
}
.navbar-nav >>> .nav-link {
  margin-left: 0;
}
.resources-drop-student {
  background: var(--kl-color-secondary);
  max-height: 32px !important;
  min-width: 20%;
  padding-top: 0.1em;
}
.resources-drop {
  flex-wrap: wrap;
  max-height: 32px !important;
  width: 20%;
  font-weight: bold;
  padding-top: 0.1em;
  color: #fff !important;
}
.resources-drop >>> .disabled {
  color: #fff !important;
}
.resources-drop:hover,
.resources-drop:hover >>> .disabled {
  background: rgb(225, 225, 225);
  cursor: pointer;
  max-height: 31px;
}
.resources-drop-item {
  width: 400px !important;
}
.resources-drop >>> .dropdown-item {
  min-width: 19em !important;
  background: var(--kl-menu-color);
  color: #fff;
}
.resources-drop >>> .dropdown-item:hover {
  background: var(--kl-menu-hover-color);
}
.resources-drop >>> .dropdown-menu {
  padding: 0 !important;
}
ul >>> .dropdown-menu li {
  margin-left: 0 !important;
}
.first-drop {
  background-color: var(--kl-menu-color) !important;
  color: #fff !important;
  transition: all 0.2s;
}
.first-drop:hover >>> .disabled {
  background-color: var(--kl-menu-hover-color) !important;
  transition: all 0.2s;
}
.second-drop {
  background-color: var(--kl-menu-color) !important;
}
.second-drop:hover >>> .disabled {
  background-color: var(--kl-menu-hover-color) !important;
  transition: all 0.2s;
}
.third-drop {
  background-color: var(--kl-menu-color) !important;
}
.third-drop:hover >>> .disabled {
  background-color: var(--kl-menu-hover-color) !important;
  transition: all 0.2s;
}
.fourth-drop {
  background-color: var(--kl-color-primary-deep) !important;
}
.fourth-drop:hover >>> .disabled {
  background-color: var(--kl-menu-hover-color) !important;
  transition: all 0.2s;
}
.brand-section {
  margin-right: 1% !important;
}
.brand-text {
  margin-left: -1%;
}
.b-nav-section {
  /* Redefinimos los tokens del menú a la paleta de marca (azul) para que
  todos los dropdowns de recursos hereden el nuevo color. */
  --kl-menu-color: #00417f;
  --kl-menu-hover-color: var(--kl-color-primary);
  width: 100%;
  max-height: 32px !important;
  font-size: 10pt;
  background: linear-gradient(
    90deg,
    var(--kl-color-primary-deep) 0%,
    var(--kl-color-primary) 60%,
    var(--kl-color-secondary) 120%
  );
  position: fixed;
  padding-left: 1%;
  top: 4.4em;
  z-index: 1000 !important;
  box-shadow: 0 6px 16px rgba(16, 38, 73, 0.12);
}
.responsive-nav-btn {
  display: none;
}
.accordion-nav {
  display: none;
}
.btn-programs {
  font-size: var(--secondary-font-size);
  font-weight: bold;
  /* transform: translateY(8%); */
  color: #fff !important;
  max-height: 32px;
  width: 17.8%;
  padding: 0 1.05em !important;
  padding-top: 0.6em !important;
  border-radius: 0;
}
.btn-programs:focus {
  outline: none;
  box-shadow: none;
  background-color: var(--kl-color-primary) !important;
  transition: all 0.2s;
  border-radius: 0;
}
.btn-programs:hover {
  background-color: var(--kl-color-primary) !important;
  transition: all 0.2s;
}
.btn-curricular-products {
  font-size: var(--secondary-font-size);
  background-color: var(--kl-color-secondary) !important;
  font-weight: bold;
  color: #fff !important;
}
.btn-curricular-products:focus {
  outline: none;
  box-shadow: none;
  background-color: var(--kl-color-secondary) !important;
  transition: all 0.2s;
  border-radius: 0;
}
.btn-curricular-products:hover {
  background-color: var(--kl-color-secondary) !important;
  transition: all 0.2s;
}
.nav li:hover >>> .dropdown-menu {
  display: block;
  margin-top: 0;
}
.b-dropdown-form {
  padding: 0px 3px 0px 3px !important;
}
/* Botón de impresión con la misma estética "ghost chip" del Modo Edición */
.b-dropdown-container {
  height: 30px;
}
.navbar-print-fab >>> .b-dropdown-container > .btn {
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--kl-border-soft);
  background: var(--kl-bg-page);
  color: var(--kl-text-heading);
  box-shadow: none;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}
.navbar-print-fab >>> .b-dropdown-container > .btn:first-child {
  padding: 0 11px;
  border-top-left-radius: 999px;
  border-bottom-left-radius: 999px;
  border-right: none;
}
.navbar-print-fab >>> .b-dropdown-container > .dropdown-toggle-split {
  padding: 0 9px;
  border-top-right-radius: 999px;
  border-bottom-right-radius: 999px;
  border-left: 1px solid var(--kl-border-soft);
}
.navbar-print-fab >>> .b-dropdown-container > .btn:hover {
  background: #eef4f7;
  border-color: #cfe0ee;
  color: var(--kl-color-primary);
}
.navbar-print-fab >>> .b-dropdown-container > .btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 110, 200, 0.15) !important;
}
/* Estado abierto/activo del dropdown: mantener el look ghost (no el azul info) */
.navbar-print-fab >>> .b-dropdown-container.show > .btn,
.navbar-print-fab >>> .b-dropdown-container > .btn.active,
.navbar-print-fab >>> .b-dropdown-container > .btn:active {
  background: #eef4f7 !important;
  border-color: #cfe0ee !important;
  color: var(--kl-color-primary) !important;
}
.b-dropdown-container-responsive {
  width: 26px;
  height: 26px;
  margin-right: 2rem !important;
}
.icon-print-navbar {
  margin-top: 0;
}
.options-print {
  font-size: 10pt;
}
.input-group-text {
  padding: 2px !important;
}
.options-print-range {
  font-size: 10pt;
  font-weight: bold;
}
.print-button {
  color: white !important;
  width: 25px;
  height: 25px;
}
.print-button:hover {
  background: var(--kl-color-secondary);
}
.print-button > .b-icon {
  transform: translateX(-20%);
}
.responsive-print-fab {
  display: none;
}
.help-icon {
  padding-top: 0 !important;
  margin-right: 10px;
  display: flex;
  align-items: center;
}
/** ----------- Media Queries ----------- **/
@media (max-width: 1200px) {
  .help-icon {
    padding-top: 0px !important;
  }
  .user-info-container {
    margin-right: 1%;
  }
  .landing-nav {
    margin-right: 1%;
    margin-left: 10%;
  }
  .profile-section {
    margin-left: 1%;
  }
  .print-button {
    margin-left: 0;
  }
  .print-button {
    width: 26px !important;
    height: 26px !important;
  }
  .responsive-nav-btn {
    width: 27px !important;
    height: 25px !important;
    margin-right: 5px !important;
  }
  .responsive-nav-icon {
    transform: translate(-39%, -13%) !important;
  }
  .print-button {
    width: 26px !important;
    height: 26px !important;
  }
  .responsive-nav-icon {
    transform: translate(-39%, -13%) !important;
  }
}

@media only screen and (min-width: 897px) and (max-width: 1400px) {
  .help-icon {
    padding-top: 3px !important;
  }
  .brand-text {
    font-size: var(--secondary-font-size) - 2;
  }
  .searchForm {
    display: none;
  }
  /* .logo {
    width: 8em;
    height: 8em;
  } */
  .right-setting {
    margin-right: 1% !important;
  }
  .user-name {
    font-size: 0.85rem;
  }
  .profile-section {
    margin-left: 1%;
    margin-bottom: 0;
  }
  .landing-nav >>> .nav-items {
    font-size: 13pt !important;
    gap: 0rem;
    margin-right: 3rem;
  }
  .navbar-nav >>> .nav-link {
    margin-left: 10px !important;
  }
  .landing-nav {
    margin-left: 10%;
    margin-right: -8%;
  }
  .brand-section {
    transform: translateX(-1em);
    margin-left: 1%;
    margin-right: -20% !important;
  }
}

@media only screen and (min-width: 701px) and (max-width: 980px) {
  .help-icon {
    padding-top: 0px !important;
  }
  .user-button {
    width: 4em;
  }
  .user-button-left {
    display: none;
  }
  .user-button-right {
    border-radius: 55px;
  }
  .brand-text {
    display: none;
  }
  .right-setting {
    margin-right: 1% !important;
  }
  .searchForm {
    display: none;
  }
  /* .logo {
    width: 8em;
    height: 8em;
  } */
  .user-name {
    display: none;
  }
  .profile-section {
    margin-left: 1%;
    margin-right: 1%;
  }
  .dropdown-adjustment >>> .dropdown-menu {
    right: 0 !important;
    left: -500%;
  }
  .profile-section >>> .dropdown-menu {
    right: 0;
    left: -22% !important;
  }
  .landing-nav {
    margin-left: 0;
    margin-right: -10%;
  }
  .landing-nav >>> .nav-link {
    font-size: var(--secondary-font-size);
  }
  .landing-nav >>> .nav-items {
    margin-right: 1vh;
    padding-bottom: 10%;
    display: none;
  }
  .mobile-nav {
    display: block;
    background-color: transparent;
  }
  .resources-b-nav {
    display: none;
  }
  .responsive-nav-btn {
    display: block;
    float: right;
    width: 30px;
    height: 29px;
    margin-top: 0.4em;
    margin-bottom: 0.1em;
    margin-right: 0.1em;
    transition: all 0.3s;
    background: var(--kl-color-secondary) !important;
    border: var(--kl-menu-hover-color) !important;
    color: var(--secondary-font-color) !important;
  }
  .responsive-nav-btn:focus {
    border: none;
  }
  .responsive-nav-btn:hover {
    background: var(--kl-color-secondary) !important;
  }
  .responsive-nav-icon {
    /* transform: translate(-15%, 10%); */
    text-align: center;
    vertical-align: middle;
  }
  .responsive-print-fab {
    display: block;
  }
  .nav-expanded {
    max-height: 800px !important;
    transition: 0.2s !important;
  }
  .accordion-nav {
    display: block;
    margin-inline: 10%;
    margin-top: -70% !important;
    transition: 0.2s;
  }
  .accordion-expanded {
    margin-top: 0% !important;
    z-index: 2000 !important;
    /* transition: .4s ease-in-out; */
  }
  .b-nav-section {
    transition: 0.1s !important;
  }
}
@media only screen and (max-width: 700px) {
  .help-icon {
    padding-top: 0px;
  }
  .user-button {
    width: 4em;
    margin-right: 10px;
  }
  .user-button-left {
    display: none;
  }
  .user-button-right {
    border-radius: 55px;
  }
  .brand-text {
    display: none;
  }
  .searchForm {
    display: none;
  }
  /* .logo {
    width: 8em;
    height: 8em;
  } */
  .user-name {
    display: none;
  }
  .nav-items {
    font-size: var(--thirth-font-size) !important;
  }
  .landing-nav {
    margin-left: 0;
    margin-right: -10%;
  }
  .landing-nav >>> .nav-link {
    font-size: var(--secondary-font-size);
  }
  .landing-nav >>> .nav-items {
    margin-right: 1vh;
    padding-bottom: 10%;
    display: none;
  }
  .mobile-nav {
    display: block;
    background-color: transparent;
  }
  /* .brand-section >>> .logo {
    min-width: 45px !important;
  } */
  .resources-b-nav {
    display: none;
  }
  .responsive-nav-btn {
    display: block;
    float: right;
    width: 25px;
    height: 25px;
    margin-top: 0.4em;
    margin-bottom: 0.1em;
    margin-right: 0.4em;
    background: var(--kl-color-secondary) !important;
    border: var(--kl-menu-hover-color) !important;
    color: var(--secondary-font-color) !important;
  }
  .responsive-nav-btn:hover {
    background: var(--kl-color-secondary) !important;
  }
  .responsive-nav-icon {
    transform: translate(-25%, -10%);
  }
  .nav-expanded {
    max-height: fit-content !important;
    transition: 0.2s linear;
    overflow: hidden;
  }
  .accordion-nav {
    display: block;
    margin-right: 11%;
    margin-left: 6%;
    margin-top: -70% !important;
    transition: 0.3s;
  }
  .accordion-expanded {
    margin-top: 0% !important;
    z-index: 2000 !important;
  }
  .dropdown-adjustment >>> .dropdown-menu {
    right: 0 !important;
    left: -500%;
  }
}
@media only screen and (max-width: 620px) {
  .help-icon {
    padding-top: 0px;
  }
  .user-button {
    width: 4em;
    margin-right: 10px;
  }
  .user-button-left {
    display: none;
  }
  .user-button-right {
    border-radius: 55px;
  }
  .user-name {
    display: none;
  }
  .nav-items {
    font-size: var(--thirth-font-size) !important;
  }
  .landing-nav >>> .nav-link {
    font-size: var(--secondary-font-size);
  }
  .profile-section {
    margin-right: 10%;
  }
  .brand-section {
    margin-right: 1% !important;
  }
  .navbar-expand .navbar-nav >>> .nav-link {
    padding: 0 !important;
  }
  .navbar-expand .navbar-nav >>> .dropdown-menu {
    font-size: 11pt;
    /* left: 1%; */
  }
  .dropdown-adjustment >>> .dropdown-menu {
    right: 0 !important;
    left: -500%;
  }
}
@media (max-width: 590px) {
  .help-icon {
    padding-top: 0px;
    margin-right: 7px;
  }
  .user-button {
    width: 4em;
    margin-right: 10px;
  }
  .user-button-left {
    display: none;
  }
  .user-button-right {
    border-radius: 55px;
  }
  .user-name {
    display: none;
  }
  .nav-items {
    font-size: var(--thirth-font-size) !important;
  }
  .profile-section {
    display: none;
  }
  .brand-section {
    margin-right: 1% !important;
  }
  .landing-nav {
    margin-left: 0;
    margin-right: -10%;
  }
  .landing-nav >>> .nav-link {
    font-size: var(--secondary-font-size);
  }
  .landing-nav >>> .nav-items {
    margin-right: 1vh;
    padding-bottom: 10%;
    display: none;
  }
  li {
    margin-left: 0;
  }
  .navbar-expand .navbar-nav >>> .nav-link {
    padding: 0 !important;
    padding-top: 0.5em !important;
  }
  .dropdown-adjustment >>> .dropdown-menu {
    right: 0 !important;
    left: -700%;
  }
  .mobile-nav {
    display: block;
    background-color: transparent;
  }
}
</style>